import React from 'react';
import { CRUD, Actions, ActionsColumn, Column, IdColumn } from "react-admin-base-bootstrap";
import { Breadcrumb } from 'react-admin-base-adminkit';
import {Card, CardBody} from "reactstrap";
import UserEntity, {roles} from "./UserEntity";

export default function Users() {
    return <Breadcrumb
        title="Users"
        data={
            [
                {
                    href: '/user',
                    name: 'Users'
                }
            ]
        }
    >
        <Card>
            <CardBody>
                <CRUD Component={UserEntity} url="/user">
                    <thead>
                        <tr>
                            <IdColumn />
                            <Column sort="name">Name</Column>
                            <Column sort="email">Email Address</Column>
                            <Column sort="type">Type</Column>
                            <ActionsColumn />
                        </tr>
                    </thead>
                    <tbody>
                    {
                        row => <tr key={row.id}>
                            <td className="min text-center">{row.id}</td>
                            <td>{row.name}</td>
                            <td>{row.email}</td>
                            <td>{roles[row.type]}</td>
                            <Actions
                                edit={"/user/" + row.id + "/edit"}
                                del={"/user/" + row.id}
                            />
                        </tr>
                    }
                    </tbody>
                </CRUD>
            </CardBody>
        </Card>
    </Breadcrumb>;
}